import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * HTTP loader for Transloco translation files
 * Loads translation JSON files from assets/i18n directory
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    /**
     * Load translation file for the specified language
     * @param lang Language code (e.g., 'en', 'es', 'fr')
     * @returns Observable of translation object
     */
    getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }
}
